<template lang="pug">
  #tracking.center-panel.md-scrollbar.md-theme-default
    .md-layout-row.heading
      h1.md-title(v-if="title") {{ (stock.name) ? title + ' на складе "' + stock.name + '"' : title }}
    md-content.md-elevation-1(md-theme="white")
      .md-flex(md-theme="white" v-if="stock.traking && Object.keys(stock.traking).length")
        md-table(md-theme="white" v-model="stock.traking" md-sort="id" md-sort-order="asc")
          md-table-row(slot="md-table-row"  slot-scope="{item}")
            md-table-cell(md-sort-by="freight.id"        md-label="ID"             ) {{item.freight.id}}
            md-table-cell(md-sort-by="traking_number"    md-label="Номер груза"    ) {{item.traking_number}}
            md-table-cell(md-sort-by="responsible_login" md-label="Ответственный"  ) {{item.responsible_login}}
            md-table-cell(md-sort-by="arrival"           md-label="Прибыл"         ) {{(item.arrival == 1) ? 'Да' : 'Нет'}}
            md-table-cell(md-sort-by="loss"              md-label="Убыл"           ) {{(item.loss == 1) ? 'Да' : 'Нет'}}
            md-table-cell(md-sort-by="arrival_date"      md-label="Дата прибытия"  ) {{item.arrival_date}}
            md-table-cell(md-sort-by="loss_date"         md-label="Дата убытия"    ) {{item.loss_date}}
            md-table-cell(md-sort-by="created_at"        md-label="Дата записи"    ) {{item.created_at}}
            md-table-cell(md-sort-by="updated_at"        md-label="Дата обновления") {{item.updated_at}}
            md-table-cell.action-container(md-label="Действия")
              span
                md-button.md-icon-button.md-dense(v-bind:to="{ name: 'FreightsTracking', params: {freight_id: item.freight.id} }"): md-icon place
                md-tooltip(md-direction="top") Отслеживание груза
              span
                md-button.md-icon-button.md-dense(v-if="item.freight.deal_id" v-bind:to="{ name: 'DealEdit', params: {dealid: item.freight.deal_id} }"): md-icon content_paste
                md-tooltip(md-direction="top") К заявке
</template>


<script>
  import moment from "moment";
  import StockMenu from './menu.vue';
  export default {
    components: {StockMenu},
    data() {
      return {
        title: 'Трекинг грузов',
        stock: {
          name: null,
          description: null,
          responsibles: [],
          sort: "100"
        }
      }
    },
    computed: {
      stocks() {
        return this.$store.state.stock.stocks;
      }
    },
    watch: {
      '$route.params.stock_id'() {
        //this.getStocks();
      },
    },
    created() {
      this.getStocks();
    },
    methods: {
      getStock() {
        return this.$store.dispatch('stock/getStock', {id: this.$route.params.stock_id}).then((stock) => {
          if (Object.keys(stock.traking).length) {
            stock.traking.forEach((traking) => {
              traking.arrival_date = (traking.arrival_date) ? moment(traking.arrival_date).format('DD.MM.YYYY HH:mm:ss') : '';
              traking.loss_date    = (traking.loss_date)    ? moment(traking.loss_date).format('DD.MM.YYYY HH:mm:ss')    : '';
              traking.created_at   = (traking.created_at)   ? moment(traking.created_at).format('DD.MM.YYYY HH:mm:ss')   : '';
              traking.updated_at   = (traking.updated_at)   ? moment(traking.updated_at).format('DD.MM.YYYY HH:mm:ss')   : '';
            })
          }
          return this.stock = Object.assign({}, stock);
        });
      },
      getStocks() {
        this.$store.dispatch('stock/getStocks', false).then(() => {
          this.$nextTick(() => this.getStock());
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Tracking.vue?64cfb998